import { render, staticRenderFns } from "./ToolbarLight.vue?vue&type=template&id=2867ae06&scoped=true&"
import script from "./ToolbarLight.vue?vue&type=script&lang=js&"
export * from "./ToolbarLight.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarLight.vue?vue&type=style&index=0&id=2867ae06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867ae06",
  null
  
)

component.options.__file = "ToolbarLight.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VToolbar,
})
